import { FetchQueryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetUsdcBalanceArgs {
  accountAddr: string;
}
export function usdcBalanceQueryKey({ accountAddr }: GetUsdcBalanceArgs) {
  return ["usdcBalance", accountAddr] as const;
}

export function usdcBalanceQuery({ accountAddr }: GetUsdcBalanceArgs) {
  return {
    queryKey: usdcBalanceQueryKey({ accountAddr }),
    queryFn: async () => {
      return await readDexSdk.usdcBalance(accountAddr);
    },
  } satisfies FetchQueryOptions;
}

export function useUsdcBalance(args: GetUsdcBalanceArgs) {
  return useSuspenseQuery(usdcBalanceQuery(args));
}

export function useUsdcBalanceQuery(args: { accountAddr: string | undefined }) {
  return useQuery({
    ...usdcBalanceQuery({ accountAddr: args.accountAddr ?? "" }),
    enabled: !!args.accountAddr,
  });
}
